export default "__VITE_ASSET__BgJZf1Mi__"